import type { Filter, Option } from "../../../types/filter";
import {
  getUniqueOptions,
  handlePrefix,
  isActiveFilter,
  type Prefix,
} from "../utils";

export type HandlingUnitsQueryParam = "handlingUnits";
export type SomethingWithHandlingUnits = Record<
  HandlingUnitsQueryParam,
  number
>;

const getHandlingUnitsOptions = (
  data: SomethingWithHandlingUnits[]
): Option[] =>
  getUniqueOptions(
    data
      .map(({ handlingUnits }) => ({
        label: handlingUnits.toLocaleString(),
        value: handlingUnits,
      }))
      .sort((a, b) => a.value - b.value)
  );

export const getHandlingUnitsFilter = (
  data: SomethingWithHandlingUnits[],
  prefix?: Prefix
): Filter => ({
  label: "Handling Units",
  queryParam: handlePrefix("handlingUnits", prefix),
  options: getHandlingUnitsOptions(data),
});

export const filterHandlingUnits = <T extends SomethingWithHandlingUnits>(
  data: T[],
  filters?: string[]
): T[] =>
  isActiveFilter(filters)
    ? data.filter((entry) => filters.includes(entry.handlingUnits.toString()))
    : data;
